/**
 * Cookie Utilities
 *
 * Pure utility functions for cookie management.
 */

/**
 * Default cookie expiration time in milliseconds (approximately 1 month)
 */
const COOKIE_EXPIRY_MILLISECONDS = 2629746000

/**
 * Gets the expiration date for user cookies
 * @returns Date object set to approximately 1 month from now
 */
export function getUserCookieExpirationDate(): Date {
	const date = new Date()
	date.setTime(date.getTime() + COOKIE_EXPIRY_MILLISECONDS)
	return date
}
